export default __webpack_public_path__ + "static/poster-6ac0bb192207b9b55c7189db8a522fd5.png";